import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Tooltip } from 'design-system-web';
import styles from './PropertyCesSyncedStatus.scss';

type Props = {
  channel: {
    property?: {
      id: string;
    } | null;
  };
};

export function PropertyCesSyncedStatus({ channel }: Props) {
  const { t } = useTranslation();
  const isNotSynced = channel.property == null;

  const statusTextKey = isNotSynced
    ? 'web.admin.channel.profile.info.notSynced'
    : 'web.admin.channel.profile.info.synced';
  
  const tooltipTextKey = isNotSynced
    ? 'web.admin.channel.profile.info.notSyncedTooltip'
    : 'web.admin.channel.profile.info.syncedTooltip';
  
  return (
    <div className={styles.syncedStatus} data-test="property-ces-synced-status">
      <Icon
        name="circle"
        set="FontAwesome"
        type="fas"
        className={
          isNotSynced ? styles.statusIconNotSynced : styles.statusIconSynced
        }
      />
      <span className={styles.statusText}>
        {t(statusTextKey)}
      </span>
      <Tooltip
        TooltipComponent={t(tooltipTextKey)}
        placement="right"
      >
        <Icon
          name="info-circle"
          set="FontAwesome"
          type="far"
          className={styles.tooltipIcon}
          testId="synced-status-info-icon"
        />
      </Tooltip>
    </div>
  );
}

; 
